export default __webpack_public_path__ + "static/media/NewSortIcon.f4f9392e.svg";